import { render, staticRenderFns } from "./FirstStepsVideo.vue?vue&type=template&id=10bff7d1&scoped=true&"
import script from "./FirstStepsVideo.vue?vue&type=script&lang=js&"
export * from "./FirstStepsVideo.vue?vue&type=script&lang=js&"
import style0 from "./FirstStepsVideo.vue?vue&type=style&index=0&id=10bff7d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bff7d1",
  null
  
)

export default component.exports